export default __webpack_public_path__ + "static/media/halkbank.cf7c0719.png";